import React from 'react';
import NoItemsPage from '../../components/NoItemsPage';
import { getTokenField } from '../../token';

const manageAccess = (WrappedComponent) =>{
  const roles = getTokenField('roles');

  return (props)=>{
    return (
        <div>
          {roles.includes('ROLE_UNIVERSAL_CONSENT_SOLUTIONS') || roles.includes('ROLE_ADMIN') ?
            <WrappedComponent {...props}/> :
            <NoItemsPage
              isBlank buttonText="contact us"
              href="https://share.hsforms.com/1-T3GKT7XQ7CzXbiutu2lUg1qa9b"
              title="Request access to Mobile Consent Solutions"
              subtitle="To learn more about Mobile Consent Solutions, please get in touch."
            />
          }
        </div>
    )
  }
};

export default manageAccess;
